import 'animate.css';
import './index.css';

import VueMask from '@devindex/vue-mask';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router/index';

import Bugsnag from '@/plugins/bugsnag.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faGoogle, faInstagram, faMicrosoft } from '@fortawesome/free-brands-svg-icons';
import { useNProgress } from '@vueuse/integrations/useNProgress';
library.add(faFacebookF, faGoogle, faMicrosoft, faInstagram);

import { createHead } from '@unhead/vue';

// Create a global head instance
const head = createHead();

// const bugsnagVue = Bugsnag.getPlugin('vue')

const app = createApp(App);

window.addEventListener('unhandledrejection', (event) => {
  console.warn('Unhandled Promise rejection:', event.reason);
});

// Catch global JavaScript errors
window.addEventListener('error', (event) => {
  // Filter out Vuetify intersection observer errors
  if (event.message?.includes('_b.call is not a function') ||
      event.filename?.includes('vuetify_components.js') ||
      event.error?.stack?.includes('onIntersect')) {
    console.warn('Filtered out Vuetify intersection observer error:', event.message);
    event.preventDefault(); // Prevent default error handling
    return false;
  }
});

// Add global error handler
app.config.errorHandler = (err, vm, info) => {
  // Filter out Vuetify intersection observer errors
  if (err.message?.includes('_b.call is not a function') ||
      err.stack?.includes('onIntersect') ||
      err.stack?.includes('vuetify_components.js')) {
    console.warn('Filtered out Vuetify intersection observer error:', err.message);
    return; // Don't send to Bugsnag
  }

  Bugsnag.notify(err, (event) => {
    event.addMetadata('vue', {
      componentName: vm?.$options?.name,
      info: info,
    });
  });
  console.error('Global error handler:', err, vm, info);
};

// Add global warn handler
app.config.warnHandler = (msg, vm, trace) => {
  Bugsnag.notify(new Error(msg), (event) => {
    event.severity = 'warning';
    event.addMetadata('vue', {
      componentName: vm?.$options?.name,
      trace: trace,
    });
  });
  console.warn('Global warn handler:', msg, vm, trace);
};

useNProgress(null, {
  parent: '#app',
});
// app.use(bugsnagVue)
app.use(head);
app.use(createPinia());
app.use(router);
app.use(vuetify);
app.use(VueQueryPlugin);
app.use(VueMask);
app.use(Vue3Toasity, {
  autoClose: 3000,
  // position: 'top-right',
  // timeout: 5000,
  // closeOnClick: true,
  // pauseOnFocusLoss: true,
  // pauseOnHover: true,
  // draggable: true,
  // draggablePercent: 0.6,
  // showCloseButtonOnHover: true,
  // closeButton: true,
  // closeButtonHtml: '<i class="fas fa-times"></i>'
});
app.mount('#app');
